import { authInstance } from './axios/index';
import notificationService from '@app/service/notificationService';
import qs from 'qs';
import { isLooseEqual } from '@app/utils/equality';


const chatService = {
  // 견적/예약 문의 채팅 메세지 전송
  sendMessage: (id, data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/chat/v1/rez/${id}/message`,
      data: JSON.stringify(data),
    };
    return authInstance(requestOptions);
  },
  // 채팅방 메세지 내역 조회
  getMessages: (id, params, logData) => {
    if (logData && (id == null || isLooseEqual(id, 'undefined'))) {
      return notificationService
        .createMessageLog(logData)
        .then((res) => console.log('res', res))
        .catch((e) => console.log('e', e))
        .finally(() => {});
    }

    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/${id}/messages?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  // 채팅방 메세지 내역 조회 (리스트)
  getMessageList: (id, params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/${id}/messages/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //
  getLastMessageSeq: (id) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/${id}/message/last-seq`,
    };
    return authInstance(requestOptions);
  },
  getChatCheckList: (id) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/message/chat-check-list?reservationIds=${id}`,
    };
    return authInstance(requestOptions);
  },
  getPeerChatCheck: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/message/peer-chat-check?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  messageCheck: (id, checkLastSeq) => {
    const requestOptions = {
      method: 'PATCH',
      url: `/api/chat/v1/rez/${id}/message-check/${checkLastSeq}`,
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의건에 대한 업체별 미확인 메세지가 있는 목록 조회
  getReservationUncheckMessage: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/message/uncheck-reservationIds?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의건에 대한 업체별 채팅 유무 및 미확인 메세지가 있는 목록 조회 (getReservationUncheckMessage 대신에 사용하게 된 api)
  getReservationChatStatus: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/message/chat-status?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  // 견적/예약 문의건에 대한 업체별 미확인 메세지가 있는 목록 조회
  getChat: (id, seq) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/chat/v1/rez/${id}/message/${seq}`,
    };
    return authInstance(requestOptions);
  },
};

export default chatService;
